import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const watchVideoService = {
  getWatchVideos: async (params = {}) => {
    try {
      const response = await api.get('/watch-videos', { params });
      return response.data;
    } catch (error) {
      console.error('Get watch videos API error:', error);
      throw error;
    }
  },

  getWatchVideo: async (id) => {
    const response = await api.get(`/watch-videos/${id}`);
    return response.data;
  },

  createWatchVideo: async (watchVideoData) => {
    const response = await api.post('/watch-videos', watchVideoData);
    return response.data;
  },

  updateWatchVideo: async (id, watchVideoData) => {
    const response = await api.put(`/watch-videos/${id}`, watchVideoData);
    return response.data;
  },

  deleteWatchVideo: async (id) => {
    const response = await api.delete(`/watch-videos/${id}`);
    return response.data;
  },

  getVideoRequests: async (status) => {
    const params = status ? { status } : {};
    console.log('[WatchVideoService] Fetching video requests from:', `${API_URL}/video-requests`, 'Params:', params);
    try {
      const response = await api.get('/video-requests', { params });
      console.log('[WatchVideoService] Success! Data:', response.data);
      return response.data;
    } catch (error) {
      console.error('[WatchVideoService] Error fetching requests:', error);
      throw error;
    }
  },

  approveVideoRequest: async (id) => {
    const response = await api.post(`/video-requests/${id}/approve`);
    return response.data;
  },

  declineVideoRequest: async ({ id, reason }) => {
    const response = await api.post(`/video-requests/${id}/decline`, { reason });
    return response.data;
  },
};

export default watchVideoService;

